function request(url, options = {}) {
	const {
		query,
		data,
		headers = {},
		responseType = 'json',
		...rest
	} = options;

	// Drop nullish values — URLSearchParams would otherwise serialize them as the
	// literal strings "undefined"/"null" and send them to the API.
	const queryString = query
		? new URLSearchParams(
				Object.entries(query).filter(
					([, value]) => value !== undefined && value !== null,
				),
			).toString()
		: '';

	const requestUrl = queryString ? `${url}?${queryString}` : url;

	const fetchOptions = {
		headers: {
			'Content-Type': 'application/json',
			...headers,
		},
		...rest,
	};

	if (data && Object.keys(data).length && rest.method !== 'GET') {
		fetchOptions.body = JSON.stringify(data);
	}

	return fetch(requestUrl, fetchOptions).then((response) => {
		if (response.status >= 400) {
			return response
				.json()
				.catch(() => ({}))
				.then((errorData) => {
					const error = new Error(
						errorData.message || response.statusText,
					);
					error.response = {
						status: response.status,
						data: errorData,
						statusText: response.statusText,
					};
					error.traceId = headers['x-trace-id'];
					throw error;
				});
		}
		const parse =
			responseType === 'text' ? response.text() : response.json();
		return parse.then((responseData) => ({
			data: responseData,
			status: response.status,
			statusText: response.statusText,
			headers: response.headers,
		}));
	});
}

const fetchClient = {
	get(url, options = {}) {
		return request(url, { ...options, method: 'GET' });
	},

	post(url, data, options = {}) {
		return request(url, { ...options, data, method: 'POST' });
	},

	put(url, data, options = {}) {
		return request(url, { ...options, data, method: 'PUT' });
	},

	patch(url, data, options = {}) {
		return request(url, { ...options, data, method: 'PATCH' });
	},

	delete(url, options = {}) {
		return request(url, { ...options, method: 'DELETE' });
	},

	request(url, options = {}) {
		return request(url, options);
	},
};

export default fetchClient;
